import React from 'react';
export function OriginStory() {
  return <section className="bg-chocolate-50 py-20 px-4" data-id="element-204">
      <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-205">
        <p className="text-xl md:text-2xl text-chocolate-800 leading-relaxed font-medium" data-id="element-206">
          Este Sistema no nació en un laboratorio. Nació de 14 meses trabajando
          con más de 200 mujeres argentinas que ya habían probado todo.
        </p>

        <div className="w-24 h-1 bg-gold-400 mx-auto rounded-full" data-id="element-207"></div>

        <p className="text-lg md:text-xl text-chocolate-800 leading-relaxed" data-id="element-208">
          Lo que descubrimos fue consistente: Cuando combinamos el dulce real
          con el soporte proteico correcto... el ciclo culpa — antojo — culpa se
          rompía en menos de 21 días.
        </p>

        <p className="text-2xl font-bold text-chocolate-900" data-id="element-209">Sin excepción.</p>
      </div>
    </section>;
}